import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from './components/pages/error/error.component';
import {MarcajeComponent} from './components/pages/marcaje/marcaje.component';
import {
    ConfiguracionCronometrajeComponent
} from './components/pages/configuracion-cronometraje/configuracion-cronometraje.component';
import {BuscarInformacionComponent} from './components/pages/buscar-informacion/buscar-informacion.component';
import {EntregarComprobanteComponent} from './components/pages/entregar-comprobante/entregar-comprobante.component';
import {
    MarcajeAdminitracionComponent
} from './components/pages/marcaje-administracion/marcaje-administracion.component';


const routes: Routes = [
    {path: '', component: ConfiguracionCronometrajeComponent},
    {path: 'configuracion-cronometraje', component: ConfiguracionCronometrajeComponent},
    {path: 'buscar-informacion', component: BuscarInformacionComponent},
    {path: 'entrega-dorsales', component: EntregarComprobanteComponent},
    {path: 'marcaje-administracion', component: MarcajeAdminitracionComponent},
    {path: 'marcaje', component: MarcajeComponent},
    {path: 'error', component: ErrorComponent},
    {path: '**', component: ErrorComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy' , onSameUrlNavigation: 'reload'})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
